import { useEffect } from 'react';
import { useLayoutLanguage } from '../context/LayoutLanguageContext';
import { useAppNavigation } from "../hooks/useAppNavigation";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

const SUPPORT_PHONE_RAW = "+18007738404";

const ErrorPage = () => {
  const { layoutT } = useLayoutLanguage();
  const { goToApplications } = useAppNavigation();
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  useEffect(() => {
    document.title = "Error Page";

    if (!isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
    }
  }, [isAuthenticated, instance]);

  const goToMyApplications = () => {
    setTimeout(() => {
      goToApplications();
    }, 50);
  };

  const contact = layoutT('go_to_my_application');

  return (
    <div className="form-q error-page" style={{ textAlign: "center" }}>
      <h1>{layoutT('internal_server_error')}</h1>

      <p>{layoutT('please_note_that')}</p>
      <p>{layoutT('you_will_be_able_to_access')}</p>

      <p>
        {contact.text}{" "}
        <a
          href={`tel:${SUPPORT_PHONE_RAW}`}
          aria-label={`Call ${contact.phoneLabel}`}
        >
          {contact.phoneLabel}
        </a>
      </p>

      <button onClick={goToMyApplications} className="btn-purple">
        {layoutT('return_to_applications')}
      </button>
    </div>
  );
};

export default ErrorPage;
